import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import Card from '../Card/Card';
import './spinner.css';
import { Copy } from 'lucide-react';
const Spinner = () => {
  const snippetContainerRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);

  const copySnippet = () => {
    if (snippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(snippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };
  return (
    <motion.div>
      <div className="spinner-container">
        <div class="carve-spinner dot-spin"></div>
        <div class="carve-spinner dash-spin"></div>
        <div class="carve-spinner infinite-spin"></div>
        <div class="carve-infinity">
          <div class="orbit">
            <div class="moon-dot"></div>
            <span class="orbit-path">
            </span>
            <div class="carve-spinner box"></div>
          </div>
        </div>
      </div>
      <div className={`center-container ${showScanning ? 'scanning' : ''}`}>

        <div className='snippet' ref={snippetContainerRef}>
          <pre>
            <code>
              <>
                <span className='cn'>&lt;div</span>
                <span className='cln'> className="</span>
                <span className='cn'>spinner-container</span>
                <span className='cln'>"</span>
                <span className='cn'>&gt;</span>
              </>
              <br />
              <>
                &nbsp;<span className='cn'>&lt;div</span>
                <span className='cln'> class="</span>
                <span className='cn'>carve-spinner dot-spin</span>
                <span className='cln'>"</span>
                <span className='cn'>&gt;&lt;/div&gt;</span>
              </>
              <br />
              <>
                &nbsp;<span className='cn'>&lt;div</span>
                <span className='cln'> class="</span>
                <span className='cn'>carve-spinner dash-spin</span>
                <span className='cln'>"</span>
                <span className='cn'>&gt;&lt;/div&gt;</span>
              </>
              <br />
              <>
                &nbsp;<span className='cn'>&lt;div</span>
                <span className='cln'> class="</span>
                <span className='cn'>carve-spinner infinite-spin</span>
                <span className='cln'>"</span>
                <span className='cn'>&gt;&lt;/div&gt;</span>
              </>
              <br />
              <>
                &nbsp;<span className='cn'>&lt;div</span>
                <span className='cln'> class="</span>
                <span className='cn'>carve-infinity</span>
                <span className='cln'>"</span>
                <span className='cn'>&gt;</span>
              </>
              <br />
              <>
                &nbsp;&nbsp;<span className='cn'>&lt;div</span>
                <span className='cln'> class="</span>
                <span className='cn'>orbit</span>
                <span className='cln'>"</span>
                <span className='cn'>&gt;</span>
              </>
              <br />
              <>
                &nbsp;&nbsp;&nbsp;<span className='cn'>&lt;div</span>
                <span className='cln'> class="</span>
                <span className='cn'>moon-dot</span>
                <span className='cln'>"</span>
                <span className='cn'>&gt;&lt;/div&gt;</span>
              </>
              <br />
              <>
                &nbsp;&nbsp;&nbsp;<span className='cn'>&lt;span</span>
                <span className='cln'> class="</span>
                <span className='cn'>orbit-path</span>
                <span className='cln'>"</span>
                <span className='cn'>&gt;&lt;/span&gt;</span>
              </>
              <br />
              <>
                &nbsp;&nbsp;&nbsp;<span className='cn'>&lt;div</span>
                <span className='cln'> class="</span>
                <span className='cn'>carve-spinner box</span>
                <span className='cln'>"</span>
                <span className='cn'>&gt;&lt;/div&gt;</span>
              </>
              <br />
              <>
                &nbsp;&nbsp;<span className='cn'>&lt;/div&gt;</span>
              </>
              <br />
              <>
                &nbsp;<span className='cn'>&lt;/div&gt;</span>
              </>
              <br />
              <>
                <span className='cn'>&lt;/div&gt;</span>
              </>
            </code>

          </pre>
        </div>
        <button aria-label="Copy Button" onClick={copySnippet}>
          <Copy />
        </button>

      </div>
    </motion.div>
  );
};

const SpinnerCard = () => {
  return (
    <Card
      CardTitle="Spinner"
      CardBody={<Spinner />}
    />
  );
};

export default SpinnerCard;
